import { clear, createStore, del, get, set } from "idb-keyval";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import DataAbstract from "./dataAbstract";

class DataIndexDb extends DataAbstract {
  constructor({
    dbName,
    storeName,
    query,
    endpoint,
    ttl = process.env.CACHE_TTL,
    identifier = "id",
  }) {
    super({ query, ttl, endpoint, identifier });
    this.storePrivate = createStore(dbName, storeName);
  }

  get store() {
    return this.storePrivate;
  }

  async getItemByTypeNumber(key) {
    if (!key && key !== 0) {
      return null;
    }
    try {
      return await get(key, this.store);
    } catch (error) {
      newRelicErrorReport(
        error,
        "web-app/web/utils/system/storage/storagesAsync/dataIndexDb.js - 33"
      );
      console.error(error);
      return null;
    }
  }

  async getItemByTypeString(key) {
    if (!key) {
      return null;
    }
    try {
      return await get(`${key}`, this.store);
    } catch (error) {
      newRelicErrorReport(
        error,
        "web-app/web/utils/system/storage/storagesAsync/dataIndexDb.js - 47"
      );
      console.error(error);
      return null;
    }
  }

  async getItem(key) {
    const data =
      (await this.getItemByTypeNumber(key)) ||
      (await this.getItemByTypeString(key));
    if (data) {
      if (
        Date.now() > data.timeExpiration ||
        Number.isNaN(data.timeExpiration)
      ) {
        await this.removeItem(key);

        return null;
      }

      return data.value;
    }

    return null;
  }

  async setItem(key, value) {
    const timeExpiration = Date.now() + this.ttl;
    try {
      await set(
        key,
        {
          value,
          timeExpiration,
        },
        this.store
      );
    } catch (error) {
      newRelicErrorReport(
        error,
        "web-app/web/utils/system/storage/storagesAsync/dataIndexDb.js - 88"
      );
      console.error(error);
    }
    return value;
  }

  async removeItem(key) {
    try {
      await del(key, this.store);
    } catch (error) {
      newRelicErrorReport(
        error,
        "web-app/web/utils/system/storage/storagesAsync/dataIndexDb.js - 101"
      );
      console.error(error);
    }
  }

  async clear() {
    try {
      await clear(this.store);
    } catch (error) {
      newRelicErrorReport(
        error,
        "web-app/web/utils/system/storage/storagesAsync/dataIndexDb.js - 113"
      );
      console.error(error);
    }
  }
}

export default DataIndexDb;
